import { html, LitElement } from "lit-element";
import "@stofloos/components/atoms/inputs/input-radiobox";

import has from "lodash-es/has";
import clone from "lodash-es/clone";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";
import { store } from "@stofloos/stores/store";
import { initRequest } from "@stofloos/actions/requests";

const rename = function(obj, key, newKey) {
	if (has(obj, key)) {
		obj[newKey] = clone(obj[key], true);

		delete obj[key];
	}

	return obj;
};

class StofwareEventProgram extends LitElement {
	static get styles() {
		return [LayoutFlex];
	}

	render() {
		const program = JSON.parse(JSON.stringify(this.program));
		program.map(program => {
			program.event_program_options.map(option => {
				option["value"] = option.id;
				if (this.selectedProgram && this.selectedProgram[program.id]) {
					option["checked"] = this.selectedProgram[program.id].includes(option.id);
				}

				if (this.enrollments && this.enrollments[program.id][option.id]) {
					const currentOption = this.enrollments[program.id][option.id];
					if (this.hideSpots) {
						option["label"] = option.title;
					} else {
						option["label"] =
							option.title +
							" (" +
							(currentOption.max_enrollments - currentOption.enrollments) +
							" plekken beschikbaar)";
					}
					option["disabled"] = currentOption.fully_booked;
				} else {
					option["label"] = option.title;
				}
			});
		});
		return html`
			<style>
				:host {
					width: 100%;

					--sw-input-radiobox-legend-margin: 10px 0;
					--sw-input-radiobox-legend-padding: 0 15px;
					--sw-input-radiobox-option-margin: 10px 15px;
					--sw-input-radiobox-option-padding: 0 15px;
					--sw-input-radiobox-options-display: block;
				}

				input-radiobox {
					flex-direction: column-reverse !important;
				}

				input-radiobox label {
					font-weight: bold;
				}
			</style>
			<div id="content-block-template">
				${program
					? html`
							${program.map(event => {
								return html`
									<input-radiobox
										type="checkbox"
										limit="${event.max_select}"
										required
										cast="number"
										class="layout vertical"
										name="${this.dataPrefix}program.${event.id}[]"
										label="${event.title}"
										.options="${event.event_program_options}"
									></input-radiobox>
								`;
							})}
					  `
					: html`
							<p style="margin: 15px;">Geen workshop opties</p>
					  `}
			</div>
		`;
	}

	static get properties() {
		return {
			program: { type: Array },
			selectedProgram: { type: Array },
			enrollments: { type: Object },
			dataPrefix: { type: String },
			data: { type: Object },
			hideSpots: { type: Boolean }
		};
	}

	constructor() {
		super();
		this.hideSpots = false;
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
	}
}

window.customElements.define("sw-event-program", StofwareEventProgram);
